import { ProductSummaryLine } from 'Components/lines/product-summary-line/ProductSummaryLine';
export default ProductSummaryLine;
